import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "pt-6" }
const _hoisted_2 = {
  key: 0,
  class: "w-full py-4 lg:pl-6"
}
const _hoisted_3 = { class: "mt-4 mb-6 flex flex-col gap-2 lg:mt-2" }
const _hoisted_4 = { class: "underline" }
const _hoisted_5 = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-lg p-4 mb-6"
}
const _hoisted_6 = { class: "text-red-800 font-medium" }
const _hoisted_7 = {
  key: 1,
  class: "text-center py-8"
}
const _hoisted_8 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_9 = {
  key: 0,
  class: "mb-6 rounded-lg border border-emerald-300 bg-emerald-50 p-4"
}
const _hoisted_10 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4" }
const _hoisted_11 = {
  key: 1,
  class: "mb-6 grid grid-cols-1 lg:grid-cols-3 gap-4 items-start"
}
const _hoisted_12 = {
  key: 2,
  class: "bg-white border border-gray-200 rounded-lg p-6 mb-6"
}
const _hoisted_13 = { class: "flex items-start gap-4" }
const _hoisted_14 = { class: "flex-1" }
const _hoisted_15 = { class: "text-sm text-black whitespace-pre-wrap" }
const _hoisted_16 = {
  key: 3,
  class: "flex flex-wrap lg:flex-nowrap gap-6 mb-6"
}
const _hoisted_17 = {
  key: 0,
  class: "flex-1 min-w-[300px] bg-blue-50 border border-blue-200 rounded-lg p-3"
}
const _hoisted_18 = { class: "text-blue-800 text-sm font-medium" }
const _hoisted_19 = {
  key: 0,
  class: "text-blue-800 text-xs mt-1"
}
const _hoisted_20 = {
  key: 4,
  class: "mb-6 rounded-lg border-2 border-amber-400 bg-amber-50 p-4"
}
const _hoisted_21 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" }
const _hoisted_22 = { class: "space-y-4" }
const _hoisted_23 = {
  key: 0,
  class: "rounded-lg border border-indigo-200 bg-indigo-50 p-4"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 1,
  class: "bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4"
}
const _hoisted_26 = { class: "text-base font-semibold text-black mb-2" }
const _hoisted_27 = { class: "flex items-center gap-3" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "fas fa-file-download text-xs"
}
const _hoisted_30 = {
  key: 1,
  class: "fas fa-spinner fa-spin text-xs"
}
const _hoisted_31 = {
  key: 0,
  class: "text-blue-800 text-xs font-medium mt-2"
}
const _hoisted_32 = {
  key: 1,
  class: "text-blue-800 text-xs font-medium mt-2"
}
const _hoisted_33 = { key: 2 }
const _hoisted_34 = {
  key: 0,
  class: "bg-white border border-gray-200 rounded-lg p-6 mb-3"
}
const _hoisted_35 = { class: "text-lg font-semibold text-black mb-4" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 1,
  class: "mb-3 flex justify-end"
}
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "space-y-4" }
const _hoisted_40 = {
  key: 0,
  class: "bg-white border border-gray-200 rounded-lg p-3"
}
const _hoisted_41 = { class: "w-full text-sm" }
const _hoisted_42 = { class: "py-1" }
const _hoisted_43 = { class: "py-1" }
const _hoisted_44 = { class: "py-1" }
const _hoisted_45 = {
  key: 1,
  class: "bg-white border border-gray-200 rounded-lg p-3"
}
const _hoisted_46 = { class: "text-sm font-semibold text-black" }
const _hoisted_47 = {
  key: 0,
  class: "mt-1 text-xs text-black"
}
const _hoisted_48 = {
  key: 1,
  class: "mt-1 text-xs text-black space-y-1"
}
const _hoisted_49 = ["href"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = {
  key: 1,
  class: "text-black text-xs ml-1"
}
const _hoisted_52 = {
  id: "statutCommande",
  class: "bg-white border border-gray-200 rounded-lg p-6 mb-6"
}
const _hoisted_53 = { class: "font-bold text-black mb-4" }
const _hoisted_54 = { class: "ml-1 font-extrabold text-blue-600" }
const _hoisted_55 = {
  key: 0,
  class: "mb-4 flex flex-wrap gap-2"
}
const _hoisted_56 = ["disabled"]
const _hoisted_57 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-1"
}
const _hoisted_58 = ["disabled"]
const _hoisted_59 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-1"
}
const _hoisted_60 = ["disabled"]
const _hoisted_61 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-1"
}
const _hoisted_62 = {
  key: 1,
  class: "fas fa-ban mr-1"
}
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-1"
}
const _hoisted_65 = {
  key: 1,
  class: "fas fa-unlock mr-1"
}
const _hoisted_66 = { class: "grid grid-cols-1 md:grid-cols-4 gap-4" }
const _hoisted_67 = { class: "flex items-start gap-2 cursor-pointer text-xs text-black" }
const _hoisted_68 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_69 = {
  key: 0,
  class: "mb-2 text-sm text-amber-600 italic"
}
const _hoisted_70 = ["disabled"]
const _hoisted_71 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_72 = ["disabled"]
const _hoisted_73 = {
  key: 0,
  class: "mt-2 text-sm text-amber-600 italic"
}
const _hoisted_74 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_75 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_76 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_77 = {
  key: 3,
  class: "text-center p-4 rounded-lg border-2 border-red-600 bg-red-50 text-red-800"
}
const _hoisted_78 = { class: "flex gap-4 mt-6" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = ["disabled"]
const _hoisted_81 = ["disabled"]
const _hoisted_82 = {
  key: 3,
  class: "w-full py-8 lg:pl-6"
}
const _hoisted_83 = {
  key: 0,
  class: "bg-white rounded-xl shadow-sm border border-gray-200 p-8"
}
const _hoisted_84 = {
  key: 0,
  class: "flex items-start gap-3 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-950 cursor-pointer"
}
const _hoisted_85 = {
  key: 1,
  class: "text-sm text-gray-600"
}
const _hoisted_86 = {
  key: 2,
  class: "text-sm text-gray-600"
}

import {
  ref,
  onMounted,
  onUnmounted,
  provide,
  computed,
  nextTick,
  watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import type {
  CarrierType,
  OrderDetailData,
  OrderDetailResponse,
  ParcelDimension,
} from "@/types";
import {
  getOrderById,
  updateOrderStatus,
  OrderConfirmationCancelledError,
  getOrderValidations,
  downloadPrecommande,
  downloadJustificatifExpedition,
  downloadSupplierInvoice,
  getUploadedInvoices,
  getOrderLabels,
  generatePackageDetailsPDF,
  saveParcelDimensions,
  type FreeShippingTrackingInput,
} from "@/api/orders";
import { mapCarrierIdToType } from "@/utils/carrierMapper";
import { mapToOrderSummary } from "@/utils/orderMapper";
import { getLabelModule, isGpxCarrier } from "@/utils/labelModuleSelector";
import { getCarrierMessage } from "@/utils/carrierMessage";
import { getTrackingUrl } from "@/utils/trackingUrl";
import ClientInfo from "@/components/order/ClientInfo.vue";
import AddressDetails from "@/components/order/AddressDetails.vue";
import OrderAdminZone from "@/components/order/OrderAdminZone.vue";
import OrderAdminAddresses from "@/components/order/OrderAdminAddresses.vue";
import OrderDetailsSection from "@/components/order/OrderDetailsSection.vue";
import LabelColissimo from "@/components/order/labels/LabelColissimo.vue";
import LabelDPD from "@/components/order/labels/LabelDPD.vue";
import LabelUPS from "@/components/order/labels/LabelUPS.vue";
import LabelEasy from "@/components/order/labels/LabelEasy.vue";
import LabelFreeShipping from "@/components/order/labels/LabelFreeShipping.vue";
import ModalComp from "@/components/ui/ModalComp.vue";
import LabelGenerationModal from "@/components/modals/LabelGenerationModal.vue";
import ConfirmParcelDimensionsModal from "@/components/modals/ConfirmParcelDimensionsModal.vue";
import CancelOrderModal from "@/components/modals/CancelOrderModal.vue";
import FreeShippingConfirmationModal from "@/components/modals/FreeShippingConfirmationModal.vue";
import { ConfirmModal } from "@/components";
import { useNotification } from "@/composables/useNotification";
import { useAuthStore } from "@/stores/auth";
import { getApiBaseUrl } from "@/config/api";
import OrderBlockingScopeModal, {
  type OrderBlockingScope,
} from "@/components/adminEFP/orders/OrderBlockingScopeModal.vue";
import { adminEfpSoftDeleteAllEtiquettes } from "@/api/adminEfp";

type ScannedParcel = NonNullable<
  OrderDetailResponse["parcelScanInfo"]
>["scannedTrackingNumbers"][number];


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderDetailsView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

// Mode admin (impersonation depuis le back-office EFP): permet de repasser une
// commande déjà confirmée en « En attente de confirmation » directement depuis
// la page de détail (même action que la modal AcheteurValidationModal).
const isAdmin = computed(() => authStore.isImpersonating);
const reverting = ref(false);
const updatingBlocking = ref(false);
const blocageModalVisible = ref(false);
const blocageDemande = ref(false);
const showConfirmRemise = ref(false);
const deleteLabelsOnRemise = ref(false);
const showCancelModal = ref(false);
const showFreeShippingConfirmationModal = ref(false);
const isConfirmingFreeShipping = ref(false);
const pendingFreeShippingStatus = ref(4);

const askRemettreEnAttente = () => {
  if (!selectedOrderId.value) return;
  // Décoché par défaut (sécurité) — l’admin doit cocher explicitement
  deleteLabelsOnRemise.value = false;
  showConfirmRemise.value = true;
};

const cancelRemettreEnAttente = () => {
  showConfirmRemise.value = false;
};

const confirmRemettreEnAttente = async () => {
  showConfirmRemise.value = false;
  if (!selectedOrderId.value) return;
  reverting.value = true;
  try {
    const shouldDeleteLabels =
      !isGroupage.value && Boolean(deleteLabelsOnRemise.value);
    const res = await fetch(
      `${getApiBaseUrl()}/api/admin-efp/commandes/${
        selectedOrderId.value
      }/remettre-en-attente`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          deleteLabels: shouldDeleteLabels,
        }),
      },
    );
    const json = await res.json();
    if (!res.ok || !json.ok) {
      throw new Error(json?.error || `Erreur ${res.status}`);
    }
    const deleted = Number(json.labels_deleted || 0);
    success(
      deleted > 0
        ? `Commande remise en attente (${deleted} étiquette${deleted > 1 ? "s" : ""} supprimée${deleted > 1 ? "s" : ""})`
        : "Commande remise en attente de confirmation",
    );
    await loadOrderData(false);
  } catch (e) {
    error(
      e instanceof Error ? e.message : "Erreur lors de la remise en attente",
    );
  } finally {
    reverting.value = false;
  }
};

const demanderModificationBlocage = (bloque: boolean) => {
  blocageDemande.value = bloque;
  blocageModalVisible.value = true;
};

const modifierBlocage = async (portee: OrderBlockingScope) => {
  if (!selectedOrderId.value || updatingBlocking.value) return;
  const bloque = blocageDemande.value;
  updatingBlocking.value = true;
  try {
    const response = await fetch(
      `${getApiBaseUrl()}/api/admin-efp/commandes/${selectedOrderId.value}/blocage`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ bloque, portee }),
      },
    );
    const result = await response.json();
    if (!response.ok || !result?.ok) {
      throw new Error(result?.message || result?.error || `Erreur ${response.status}`);
    }
    if (orderData.value && Number(result.statut) >= 0) {
      orderData.value.statut = Number(result.statut);
    }
    if (orderDetailResponse.value && Number(result.statut) >= 0) {
      orderDetailResponse.value.statut = Number(result.statut);
    }
    blocageModalVisible.value = false;
    success(
      portee === "groupe"
        ? bloque
          ? "Commandes du groupe bloquées"
          : "Commandes du groupe débloquées"
        : bloque
          ? "Commande bloquée"
          : "Commande débloquée",
    );
    await loadOrderData(false);
  } catch (exception) {
    error(
      exception instanceof Error
        ? exception.message
        : "Erreur lors de la modification du blocage",
    );
  } finally {
    updatingBlocking.value = false;
  }
};
// État
const selectedOrderId = ref<number | null>(null);
const orderData = ref<OrderDetailData | null>(null);
const orderCarrier = ref<CarrierType | null>(null);
const orderCarrierLibelle = ref<string | null>(null); // Libellé exact depuis la DB
const showOrderSummary = ref(false);
const isGroupage = ref(false);
// Vue simplifiée lorsqu'on arrive depuis la gestion des groupages
const isFromGroupage = computed(() => route.query.from === "groupage");
const canConfirm = ref(false);
const replacementConfirmation = ref(false);
watch(selectedOrderId, () => { replacementConfirmation.value = false; }, { flush: 'sync' });
const brexitChecked = ref(false);
const orderDetailResponse = ref<OrderDetailResponse | null>(null);

const scannedParcels = computed<ScannedParcel[]>(
  () => orderDetailResponse.value?.parcelScanInfo?.scannedTrackingNumbers ?? [],
);

const getScannedParcelLabel = (item: ScannedParcel): string => {
  if (item.parcelNumber != null) return `Colis n°${item.parcelNumber}`;
  return /^\d+$/.test(item.tracking)
    ? `Colis n°${item.tracking}`
    : `Numéro scanné : ${item.tracking}`;
};

const isDpdDelivery = (carrierId?: number | null): boolean =>
  [10, 13, 2743].includes(Number(carrierId));

const formatScannedTracking = (
  tracking: string,
  carrierId?: number | null,
): string =>
  isDpdDelivery(carrierId) && !tracking.startsWith("092")
    ? `092${tracking}`
    : tracking;

const getScannedTrackingUrl = (
  tracking: string,
  carrierId?: number | null,
): string | null =>
  getTrackingUrl(
    isDpdDelivery(carrierId) && tracking.startsWith("092")
      ? tracking.slice(3)
      : tracking,
    carrierId,
  );

const isLoading = ref(false);
const errorMessage = ref<string | null>(null);
const disableAction = ref(true);
const activeExpedi = ref(true);
const canConfirmGroupage = ref(true);
const canReadyForPickup = ref(true);
// Validations détaillées pour les messages d'aide
// Vérifier si au moins une facture existe
const hasUploadedInvoices = ref(false);
const invoicesCount = ref(0);

// États pour les collapses
const isOrderDetailsCollapsed = ref(true);
const isClientInfoCollapsed = ref(true);
const isAddressDetailsCollapsed = ref(true);

const GROUPAGE_WITHOUT_PACKAGE_DETAILS_IDS: string[] = [];

const groupageReadiness = computed(() => {
  return orderDetailResponse.value?.groupageReadiness || null;
});

const shouldShowGroupageReadiness = computed(() => {
  if (!isGroupage.value) return false;
  if (!orderData.value?.id_livraison) return false;
  const id = String(orderData.value.id_livraison);
  if (!GROUPAGE_WITHOUT_PACKAGE_DETAILS_IDS.includes(id)) return false;
  return !!groupageReadiness.value;
});

const isPickupEffectue = computed(() => {
  return (
    isGroupage.value &&
    [8, 14].includes(Number(orderData.value?.statut))
  );
});

const canAdminGenerateUsFinalLabels = computed(
  () =>
    isAdmin.value &&
    isGroupage.value &&
    [8, 14].includes(Number(orderData.value?.statut)) &&
    orderDetailResponse.value?.requiresUsCustomsCompliance === true,
);

const pickupStepLabel = computed(() => {
  if (Number(orderData.value?.statut) === 14) return "Reçu au dépôt";
  return isPickupEffectue.value ? "Pickup effectué" : "Attente d'enlèvement";
});

// Computed pour déterminer si on doit afficher la section d'impression des détails de colis
// Afficher pour: groupages OU transporteurs propres du client (non gérés par eFashion)
const shouldShowPackageDetails = computed(() => {
  if (!orderData.value) return false;

  // Vérifier que la commande est confirmée (dont 14 = reçue au dépôt).
  const statut = orderData.value.statut || 0;
  const isCommandeConfirmee = [2, 4, 7, 8, 9, 14].includes(statut);
  if (!isCommandeConfirmee) return false;
  if (isGroupage.value && [2, 8, 14].includes(Number(statut))) {
    return false;
  }
  if (isFreeShippingOrder.value) return false;
  if (isOwnCarrierDirectOrder.value) return true;

  const idLivraison = orderData.value.id_livraison;
  if (!idLivraison || isNaN(idLivraison)) return true;

  return (
    isGroupage.value &&
    !GROUPAGE_WITHOUT_PACKAGE_DETAILS_IDS.includes(String(idLivraison))
  );
});

// Pour les groupages, afficher la zone étiquettes pour les transporteurs hors liste d'exclusion
const shouldShowLabelZone = computed(() => {
  if (canAdminGenerateUsFinalLabels.value) return true;
  if (!orderData.value?.statut) return false;
  const statut = Number(orderData.value.statut);
  if (![2, 4, 7, 8, 9, 14].includes(statut)) return false;
  const id = Number(orderData.value.id_livraison);

  return (
    !isGroupage.value ||
    (id && GROUPAGE_WITHOUT_PACKAGE_DETAILS_IDS.includes(String(id)))
  );
});

/** Document acheteur : disponible dès qu'il y a des étiquettes ou une expédition. */
const canPrintJustificatifExpedition = computed(() => {
  if (!orderData.value) return false;
  const statut = Number(orderData.value.statut);
  if ([1, 3].includes(statut) || statut <= 0) return false;
  if (hasExistingLabels.value) return true;
  if (orderDetailResponse.value?.dateExpedition) return true;
  return [2, 7, 8, 14].includes(statut);
});

const canShowLabelGenerateCta = computed(() => {
  if (!orderData.value || isGroupage.value) return false;
  if (isClientTransporterOrder.value) return false;
  const statut = Number(orderData.value.statut);
  if ([1, 3, 9].includes(statut) || statut <= 0) return false;
  const idLivraison = Number(orderData.value.id_livraison);
  if (!idLivraison || idLivraison === 2 || idLivraison === 3) return false;
  if (!getLabelModule(idLivraison)) return false;
  return !hasExistingLabels.value;
});

const canShowAdminRegenerateLabelsCta = computed(() => {
  if (!isAdmin.value) return false;
  if (!orderData.value || isGroupage.value) return false;
  if (isClientTransporterOrder.value) return false;
  if (!hasExistingLabels.value) return false;
  const statut = Number(orderData.value.statut);
  if (![2, 4].includes(statut)) return false;
  const idLivraison = Number(orderData.value.id_livraison);
  if (!idLivraison || idLivraison === 2 || idLivraison === 3) return false;
  return Boolean(getLabelModule(idLivraison));
});

// État pour la génération
const isGeneratingPackageDetails = ref(false);
const showConfirmDimensionsModal = ref(false);
const isSavingParcelDimensions = ref(false);

const hasExistingLabels = ref(false);
const isCheckingLabels = ref(false);
const isGeneratingAdminUsLabels = ref(false);
const isAdminRegeneratingLabels = ref(false);
const showConfirmAdminRegenerateLabels = ref(false);

const normalizeParcelDimension = (
  dim: Record<string, unknown> | unknown[],
): ParcelDimension => {
  const values = Array.isArray(dim)
    ? dim
    : [dim.longueur, dim.largeur, dim.hauteur, dim.poids];
  const numberOrNull = (value: unknown) => {
    const parsed = Number(value);
    return value !== "" && value != null && Number.isFinite(parsed)
      ? parsed
      : null;
  };
  return {
    longueur: numberOrNull(values[0]),
    largeur: numberOrNull(values[1]),
    hauteur: numberOrNull(values[2]),
    poids: numberOrNull(values[3]),
  };
};

const existingParcelDimensions = computed<ParcelDimension[]>(() => {
  const raw: unknown = (orderDetailResponse.value as { data?: unknown } | null)
    ?.data;
  let parsed: unknown = {};
  if (typeof raw === "string") {
    try {
      parsed = JSON.parse(raw);
    } catch {
      parsed = {};
    }
  } else if (raw) {
    parsed = raw;
  }
  const infocolis = (
    parsed as {
      infocolis?: { dimensioncolis?: unknown; nbcolis?: unknown };
    } | null
  )?.infocolis;
  const list = Array.isArray(infocolis?.dimensioncolis)
    ? infocolis.dimensioncolis
    : [];
  const nbColis =
    Number(orderDetailResponse.value?.nb_colis) ||
    Number(infocolis?.nbcolis) ||
    list.length ||
    1;
  return Array.from({ length: nbColis }, (_, index) =>
    normalizeParcelDimension(
      (list[index] || {}) as Record<string, unknown> | unknown[],
    ),
  );
});

// Message d'information transporteur (normal vs groupage)
const carrierMessage = computed(() => {
  if (!orderData.value?.id_livraison) {
    return null;
  }

  const idLivraison = Number(orderData.value.id_livraison);

  // Pas de message pour retrait en magasin et livraison offerte
  if (idLivraison === 2 || idLivraison === 3) {
    return null;
  }

  const dateExpedition = orderDetailResponse.value?.dateExpedition || undefined;

  return getCarrierMessage(
    isGroupage.value,
    dateExpedition,
    orderCarrierLibelle.value || undefined,
  );
});

const isClientTransporterOrder = computed(() => {
  const livraison = orderDetailResponse.value?.livraison;
  return livraison?.id_acheteur != null;
});

const isOwnCarrierDirectOrder = computed(() =>
  isClientTransporterOrder.value &&
  orderDetailResponse.value?.commandeGroupe?.groupage != null &&
  Number(orderDetailResponse.value.commandeGroupe.groupage) === 0 &&
  orderData.value?.id_livraison != null &&
  ![2, 3].includes(Number(orderData.value.id_livraison)),
);

const shouldShowParcelScanInfo = computed(() => {
  if (!orderDetailResponse.value?.parcelScanInfo) return false;
  const statut = Number(orderData.value?.statut || 0);
  // "Nouveau" dans l'app: 1 et 9
  return ![1, 9].includes(statut);
});

// Gérer la génération du PDF
const downloadPackageDetailsPDF = async (colis?: ParcelDimension[]) => {
  if (!selectedOrderId.value) return;

  // Ouvrir tout de suite un onglet pour eviter le blocage popup
  const openedWindow = window.open("", "_blank");

  isGeneratingPackageDetails.value = true;
  try {
    const result = await generatePackageDetailsPDF(
      selectedOrderId.value,
      colis,
    );

    // Rediriger l'onglet ouvert vers le PDF genere
    if (result.generateUrl) {
      if (openedWindow) {
        openedWindow.location.href = result.generateUrl;
      } else {
        window.open(result.generateUrl, "_blank");
      }
      success(
        "Génération du PDF lancée. Le fichier sera disponible après génération.",
      );
    } else {
      throw new Error("URL storage du PDF absente");
    }
  } catch (err) {
    if (openedWindow && !openedWindow.closed) {
      openedWindow.close();
    }
    error(
      err instanceof Error
        ? err.message
        : "Erreur lors de la génération du PDF",
    );
  } finally {
    isGeneratingPackageDetails.value = false;
  }
};

const handleGeneratePackageDetails = async () => {
  if (!selectedOrderId.value) return;

  // Ouvrir la modale même sans facture : l'upload est proposé dans la modale.
  await checkInvoices();
  showConfirmDimensionsModal.value = true;
};

const handleConfirmDimensionsAndDownload = async (
  dimensions: ParcelDimension[],
) => {
  if (!selectedOrderId.value) return;

  await checkInvoices();
  if (!hasUploadedInvoices.value) {
    return;
  }

  isSavingParcelDimensions.value = true;
  try {
    await saveParcelDimensions(selectedOrderId.value, dimensions);
    showConfirmDimensionsModal.value = false;
    // Passer les dimensions au générateur pour éviter une relecture BDD obsolète
    await downloadPackageDetailsPDF(dimensions);
    await loadOrderData(false);
  } catch (err) {
    error(
      err instanceof Error
        ? err.message
        : "Erreur lors de l'enregistrement des dimensions",
    );
  } finally {
    isSavingParcelDimensions.value = false;
  }
};

const refreshLabelsState = async () => {
  if (!selectedOrderId.value) {
    hasExistingLabels.value = false;
    return;
  }

  isCheckingLabels.value = true;
  try {
    const labels = await getOrderLabels(selectedOrderId.value);
    hasExistingLabels.value = labels.length > 0;
  } catch {
    // En cas d'erreur, ne pas bloquer l'UI et considérer "pas d'étiquette"
    hasExistingLabels.value = false;
  } finally {
    isCheckingLabels.value = false;
  }
};

const handleRegenerateLabels = () => {
  showRegenerateLabelModal.value = true;
};

const askAdminRegenerateNormalLabels = () => {
  if (!selectedOrderId.value || !canShowAdminRegenerateLabelsCta.value) return;
  showConfirmAdminRegenerateLabels.value = true;
};

const confirmAdminRegenerateNormalLabels = async () => {
  showConfirmAdminRegenerateLabels.value = false;
  if (!selectedOrderId.value) return;

  isAdminRegeneratingLabels.value = true;
  try {
    const result = await adminEfpSoftDeleteAllEtiquettes(selectedOrderId.value);
    if (!result.ok) {
      throw new Error(result.error || "Impossible de supprimer les étiquettes");
    }
    await refreshLabelsState();
    success(
      result.deleted && result.deleted > 0
        ? `${result.deleted} étiquette${result.deleted > 1 ? "s" : ""} supprimée${result.deleted > 1 ? "s" : ""} — vous pouvez en générer de nouvelles`
        : "Aucune étiquette à supprimer — vous pouvez générer",
    );
    showRegenerateLabelModal.value = true;
  } catch (err) {
    error(
      err instanceof Error
        ? err.message
        : "Impossible de préparer la régénération des étiquettes",
    );
  } finally {
    isAdminRegeneratingLabels.value = false;
  }
};

const generateAdminUsFinalLabels = async () => {
  const idCommande = selectedOrderId.value;
  const idCommandeGroupe = Number(
    orderDetailResponse.value?.id_commande_groupe,
  );
  if (!idCommande || !Number.isInteger(idCommandeGroupe)) return;

  isGeneratingAdminUsLabels.value = true;
  try {
    const response = await fetch(
      `${getApiBaseUrl()}/api/admin-efp/groupages/genetiquette-easy`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idCommandeGroupe, idCommande }),
      },
    );
    const result = await response.json();
    if (!response.ok || !result.success) {
      throw new Error(
        result.message || "Impossible de générer les étiquettes USA",
      );
    }
    success("Étiquettes USA générées pour cette commande uniquement");
    await loadOrderData(false);
    await refreshLabelsState();
  } catch (err) {
    error(
      err instanceof Error
        ? err.message
        : "Impossible de générer les étiquettes USA",
    );
  } finally {
    isGeneratingAdminUsLabels.value = false;
  }
};

// Computed pour créer un objet de props pour LabelEsendeo

// Vérifier les factures existantes (utilisé pour les validations internes)
const checkInvoices = async () => {
  if (!selectedOrderId.value) return;
  try {
    const invoices = await getUploadedInvoices(selectedOrderId.value);
    invoicesCount.value = invoices.length;
    hasUploadedInvoices.value = invoices.length > 0;
  } catch (error) {
    invoicesCount.value = 0;
    hasUploadedInvoices.value = false;
  }
};

// Modal de confirmation
const showConfirmModal = ref(false);
const confirmModalTitle = ref("");
const confirmModalMessage = ref("");
const pendingAction = ref<(() => Promise<void>) | null>(null);
const showLabelGenerationModal = ref(false);
const showRegenerateLabelModal = ref(false);
const pendingGroupageStatus = ref<number | null>(null);

// Notifications
const { success, error } = useNotification();

// Déterminer le module d'étiquette à utiliser
const labelModule = computed(() => {
  if (orderData.value && orderData.value.id_livraison == null) {
    return "freeShipping";
  }
  if (!orderData.value?.id_livraison) return null;
  return getLabelModule(orderData.value.id_livraison);
});

const isFreeShippingOrder = computed(
  () => Boolean(orderData.value) && orderData.value?.id_livraison == null,
);

// Détecter si la commande est à destination du Royaume-Uni (code GB ou id_pays = 24)
const isUKOrder = computed(() => {
  const pays = orderDetailResponse.value?.adresseLivraison?.pays;
  return pays?.code === "GB" || pays?.id_pays === 24;
});

// Messages d'aide pour expliquer pourquoi le bouton est désactivé
const confirmButtonHelpMessage = computed(() => {
  // Commande normale (non groupage)
  if (orderData.value?.statut === 1 && !isGroupage.value) {
    if (!disableAction.value) {
      return "Vous ne pouvez pas confirmer : la facture mensuelle a déjà été générée pour ce mois.";
    }
    if (isUKOrder.value && !brexitChecked.value) {
      return "Veuillez cocher la case Brexit pour confirmer la commande.";
    }
    return null;
  }

  // Commande groupage
  // Plus de blocage lié à la facture (gérée dans la modal)
  return null;
});

// Fournir les données aux composants enfants via provide/inject
// Créer un objet réactif avec la valeur de orderDetailResponse
provide(
  "orderDetailData",
  computed(() => ({ value: orderDetailResponse.value })),
);

// Méthodes
const handleGoBack = () => {
  // Si on vient de la gestion des groupages, revenir au groupage d'origine
  if (route.query.from === "groupage") {
    router.push({
      name: "adminEFP/groupage-detail",
      params: { id: route.query.groupeId as string },
    });
    return;
  }
  // Conserver les query parameters lors du retour vers la liste
  router.push({
    name: "myorders",
    query: route.query, // Conserver tous les filtres dans l'URL
  });
};

const handleDownloadPrecommande = async () => {
  if (!selectedOrderId.value) return;

  try {
    isLoading.value = true;
    await downloadPrecommande(selectedOrderId.value);
    success("Pré-commande téléchargée avec succès");
  } catch (err: unknown) {
    const errorMessage =
      err instanceof Error
        ? err.message
        : "Erreur lors du téléchargement de la pré-commande";
    error(errorMessage);
  } finally {
    isLoading.value = false;
  }
};

const handleDownloadJustificatifExpedition = async () => {
  if (!selectedOrderId.value) return;

  try {
    isLoading.value = true;
    await downloadJustificatifExpedition(selectedOrderId.value);
    success("Justificatif d'expédition généré avec succès");
  } catch (err: unknown) {
    error(
      err instanceof Error
        ? err.message
        : "Erreur lors de la génération du justificatif d'expédition",
    );
  } finally {
    isLoading.value = false;
  }
};

const handleDownloadSupplierInvoice = async () => {
  if (!selectedOrderId.value) return;

  try {
    isLoading.value = true;
    await downloadSupplierInvoice(selectedOrderId.value);
    success("Facture téléchargée avec succès");
  } catch (err: unknown) {
    error(
      err instanceof Error
        ? err.message
        : "Erreur lors du téléchargement de la facture",
    );
  } finally {
    isLoading.value = false;
  }
};

// Fonctions pour gérer les classes CSS avec le design original
const getStatusClass = (
  step: string,
  statut: number | null | undefined,
  groupage: boolean,
): string => {
  if (!statut) return "border-gray-200 bg-gray-50";

  switch (step) {
    case "attente":
      if (statut === 1 && !groupage) return "border-yellow-300 bg-yellow-50";
      if ((statut === 1 || statut === 9) && groupage) {
        const statutNum = Number(statut);
        const isExpediee =
          (statutNum >= 7 && statutNum !== 9) || statutNum === 2;
        return isExpediee
          ? "border-green-500 bg-green-50"
          : "border-yellow-300 bg-yellow-50";
      }
      return "border-gray-200 bg-gray-50";

    case "confirm":
      if (statut === 1 || statut === 3) return "border-gray-200 bg-gray-50";
      return "border-blue-300 bg-blue-50";

    case "attenteEnlevement":
      if ([7, 8, 14].includes(statut)) {
        const statutNum = Number(statut);
        const isPickupEffectue = [8, 14].includes(statutNum);
        return isPickupEffectue
          ? "border-lime-400 bg-lime-50"
          : "border-blue-300 bg-blue-50";
      }
      return "border-gray-200 bg-gray-50";

    case "expediee":
      if (statut === 2) return "border-green-500 bg-green-50";
      return "border-gray-200 bg-gray-50";

    case "annulee":
      if (statut === 3) return "border-red-300 bg-red-50";
      return "border-gray-200 bg-gray-50";

    default:
      return "border-gray-200 bg-gray-50";
  }
};

const getStatusIconClass = (
  step: string,
  statut: number | null | undefined,
  groupage: boolean,
): string => {
  if (!statut) return "bg-gray-400";

  switch (step) {
    case "attente":
      if (statut === 1 && !groupage) return "bg-yellow-400";
      if ((statut === 1 || statut === 9) && groupage) {
        const statutNum = Number(statut);
        const isExpediee =
          (statutNum >= 7 && statutNum !== 9) || statutNum === 2;
        return isExpediee ? "bg-green-500" : "bg-yellow-400";
      }
      return "bg-gray-400";

    case "confirm":
      if (statut === 1 || statut === 3) return "bg-gray-400";
      return "bg-blue-500";

    case "attenteEnlevement":
      if ([7, 8, 14].includes(statut)) {
        const statutNum = Number(statut);
        const isPickupEffectue = [8, 14].includes(statutNum);
        return isPickupEffectue ? "bg-lime-400" : "bg-blue-500";
      }
      return "bg-gray-400";

    case "expediee":
      if (statut === 2) return "bg-green-500";
      return "bg-gray-400";

    case "annulee":
      if (statut === 3) return "bg-red-500";
      return "bg-gray-400";

    default:
      return "bg-gray-400";
  }
};

const getStatusTextClass = (
  step: string,
  statut: number | null | undefined,
  groupage: boolean,
): string => {
  if (!statut) return "text-black";

  switch (step) {
    case "attente":
      if (statut === 1 && !groupage) return "text-black";
      if ((statut === 1 || statut === 9) && groupage) {
        const statutNum = Number(statut);
        const isExpediee =
          (statutNum >= 7 && statutNum !== 9) || statutNum === 2;
        return isExpediee ? "text-green-700" : "text-black";
      }
      return "text-black";

    case "confirm":
      if (statut === 1 || statut === 3) return "text-black";
      return "text-black";

    case "attenteEnlevement":
      if ([7, 8, 14].includes(statut)) {
        const statutNum = Number(statut);
        const isPickupEffectue = [8, 14].includes(statutNum);
        return isPickupEffectue ? "text-lime-700" : "text-gray-900";
      }
      return "text-black";

    case "expediee":
      if (statut === 2) return "text-green-700";
      return "text-black";

    case "annulee":
      if (statut === 3) return "text-red-700";
      return "text-black";

    default:
      return "text-black";
  }
};

// Exécuter l'action en attente après confirmation
const executePendingAction = async () => {
  if (pendingAction.value) {
    await pendingAction.value();
    pendingAction.value = null;
  }
};

// Actions pour modifier le statut
const handleConfirmOrder = async (
  newStatus: number,
  reasonCode?: string,
  reasonDetail?: string,
  freeShippingTracking?: FreeShippingTrackingInput,
  showPageLoading = true,
): Promise<boolean> => {
  if (!selectedOrderId.value || !disableAction.value) return false;

  try {
    if (showPageLoading) isLoading.value = true;
    const updatedOrder = await updateOrderStatus(
      selectedOrderId.value,
      newStatus,
      reasonCode,
      reasonDetail,
      freeShippingTracking,
    );

    // Recharger les données
    await loadOrderData();

    // Toast de succès
    const statusMessages: Record<number, string> = {
      2: "Commande expédiée avec succès",
      3: "Commande annulée",
      4: "Commande confirmée avec succès",
      7: "Commande marquée comme prête pour pickup",
      8: "Commande confirmée avec succès",
    };
    const closedEmptyOrder = [4, 7, 8].includes(newStatus) && updatedOrder?.statut === 3;
    success(closedEmptyOrder ? "Aucun article à expédier : commande clôturée et annulée." : statusMessages[newStatus] || "Statut modifié avec succès");
    return true;
  } catch (err) {
    if (err instanceof OrderConfirmationCancelledError) return false;
    error(
      err instanceof Error
        ? err.message
        : "Erreur lors de la modification du statut de la commande",
    );
    return false;
  } finally {
    if (showPageLoading) isLoading.value = false;
  }
};

const handleConfirmFreeShipping = async (
  tracking: FreeShippingTrackingInput,
) => {
  isConfirmingFreeShipping.value = true;
  try {
    const confirmed = await handleConfirmOrder(
      pendingFreeShippingStatus.value,
      undefined,
      undefined,
      tracking,
      false,
    );
    if (confirmed) showFreeShippingConfirmationModal.value = false;
  } finally {
    isConfirmingFreeShipping.value = false;
  }
};

const handleConfirmOrderClick = (newStatus: number, actionName: string) => {
  if (!selectedOrderId.value || !disableAction.value) return;

  // Groupage US : notice conformité avant confirmation (sans dimensions)
  if (
    (newStatus === 7 || newStatus === 8) &&
    isGroupage.value &&
    orderDetailResponse.value?.requiresUsCustomsCompliance === true &&
    orderDetailResponse.value?.usCustomsNoticeAccepted !== true
  ) {
    showLabelGenerationModal.value = true;
    return;
  }

  if ([4, 7, 8].includes(newStatus) && isFreeShippingOrder.value) {
    pendingFreeShippingStatus.value = newStatus;
    showFreeShippingConfirmationModal.value = true;
    return;
  }

  // Transporteur acheteur : dimensions + facture dans la modal, statut 7
  if (newStatus === 4 && isClientTransporterOrder.value) {
    showLabelGenerationModal.value = true;
    return;
  }

  // Messages de confirmation selon l'action
  if ([4, 7, 8].includes(newStatus)) {
    void handleConfirmOrder(newStatus);
    return;
  }
  const confirmMessages: Record<number, string> = {
    2: "Êtes-vous sûr de vouloir expédier cette commande ?",
    3: "Êtes-vous sûr de vouloir annuler cette commande ?",
  };

  confirmModalTitle.value = `Confirmer ${actionName}`;
  confirmModalMessage.value =
    confirmMessages[newStatus] ||
    "Êtes-vous sûr de vouloir effectuer cette action ?";
  pendingAction.value = () => handleConfirmOrder(newStatus);
  showConfirmModal.value = true;
};

// Après labels / notice US groupage : confirmer le statut si besoin
const handleLabelsGenerated = async () => {
  if (isGroupage.value && pendingGroupageStatus.value !== null) {
    await handleConfirmOrder(pendingGroupageStatus.value);
    pendingGroupageStatus.value = null;
  }
  await loadOrderData(false);
  await refreshLabelsState();
};

// Variante "régénération" : même formulaire, mais sans logique de confirmation de statut
const handleLabelsRegenerated = () => {
  loadOrderData(false);
  refreshLabelsState();
  success("Étiquettes régénérées avec succès");
};

const handleConfirmOrderGroupage = () => {
  if (!selectedOrderId.value || !disableAction.value) return;

  // Pour le groupage, si statut = 9, passer à 8, sinon passer à 7
  const newStatus = orderData.value?.statut === 9 ? 8 : 7;

  // Stocker le statut cible (utile si notice US via LabelGenerationModal)
  pendingGroupageStatus.value = newStatus;

  handleConfirmOrderClick(newStatus, "la confirmation");
};

const handleCancelOrder = () => {
  if (!selectedOrderId.value || !disableAction.value) return;
  showCancelModal.value = true;
};

const confirmCancelOrder = async (
  reasonCode: string,
  reasonDetail?: string,
) => {
  await handleConfirmOrder(3, reasonCode, reasonDetail);
  showCancelModal.value = false;
};

// Fonction pour charger les données de la commande
const loadOrderData = async (showLoading = true) => {
  if (!selectedOrderId.value) return false;

  if (showLoading) {
    isLoading.value = true;
  }
  errorMessage.value = null;

  // Vérifier les factures pour les validations internes
  try {
    await checkInvoices();
  } catch (error) {
    // Erreur silencieuse
  }

  try {
    const data: OrderDetailResponse | null = await getOrderById(
      selectedOrderId.value,
    );

    // Vérifier si la commande existe
    if (!data) {
      errorMessage.value = "Commande introuvable";
      isLoading.value = false;
      return false;
    }

    // Stocker la réponse complète pour les composants enfants
    // Mapper Commentaires (C majuscule) vers commentaires (c minuscule) si nécessaire
    // car GraphQL peut retourner le nom exact tel qu'il est dans l'entité
    if ((data as any).Commentaires !== undefined) {
      // Utiliser Commentaires (C majuscule) si commentaires (c minuscule) n'existe pas ou est null
      if (data.commentaires === undefined || data.commentaires === null) {
        data.commentaires = (data as any).Commentaires;
      }
    }
    orderDetailResponse.value = data;

    // Mapper les données de l'API vers orderData
    const summary = mapToOrderSummary(data);
    orderData.value = {
      totalHT: summary.totalHT,
      tva: summary.tva,
      totalTTC: summary.totalTTC,
      quantityTotal: summary.quantityTotal,
      weight: summary.weight,
      packages: summary.packages,
      id_livraison: data.id_livraison ?? data.livraison?.id_livraison ?? null,
      statut: data.statut,
      groupage: data.groupage,
      carrierMessage: data.livraison?.commentaires || undefined,
      idCommandeName: data.id_commande_name || undefined,
    };

    // Mapper le transporteur (pour le badge visuel uniquement) - seulement si livraison existe
    if (data.livraison) {
      orderCarrier.value = mapCarrierIdToType(data.livraison.id_livraison);
      // Stocker le libellé exact depuis la DB (comme dans la liste)
      orderCarrierLibelle.value = data.livraison.libelle;
    } else {
      orderCarrier.value = null;
      orderCarrierLibelle.value = null;
    }

    // Afficher le récapitulatif si statut = 4
    showOrderSummary.value = data.statut === 4;

    // Un GPX unique en UE peut encore générer son étiquette directement.
    // Une destination hors UE reste en groupage, même avec un seul colis GPX.
    const isSingleGpxOrder =
      isGpxCarrier(data.id_livraison) &&
      Number(data.groupageReadiness?.countTotal) === 1;
    const explicitGroupage =
      data.commandeGroupe?.groupage === 1 || data.groupage === true;
    const singleGpxShipsDirect =
      isSingleGpxOrder && data.outsideEuShippingZone !== true;
    isGroupage.value = explicitGroupage && !singleGpxShipsDirect;

    // Peut confirmer si statut = 1 (en attente)
    canConfirm.value = data.statut === 1;

    // Charger les validations
    await loadOrderValidations();
    await refreshLabelsState();
    return true;
  } catch (error) {
    if (error instanceof Error) {
      errorMessage.value = error.message.includes("introuvable")
        ? "Commande introuvable"
        : "Erreur lors du chargement de la commande";
    } else {
      errorMessage.value = "Erreur lors du chargement de la commande";
    }
    return false;
  } finally {
    if (showLoading) {
      isLoading.value = false;
    }
  }
};

// Fonction de rechargement silencieux (sans afficher le spinner)
const reloadOrderDataSilent = async () => {
  return loadOrderData(false);
};

// Fournir la fonction de rechargement pour permettre la mise à jour dynamique
// (après la déclaration de loadOrderData)
provide("reloadOrderData", reloadOrderDataSilent);

// Gérer l'upload d'une facture
const handleInvoiceUploaded = async (
  action: "upload" | "delete" = "upload",
) => {
  // Vérifier immédiatement les factures pour mettre à jour hasUploadedInvoices
  await checkInvoices();
  // Recharger les validations pour mettre à jour les autres flags
  await loadOrderValidations();

  // Ne pas ouvrir automatiquement la modal lors d'une suppression de facture
  if (action !== "upload") return;

  // Si la commande est en attente après upload, ouvrir directement la modal de confirmation
  const currentStatus = orderData.value?.statut;
  if (!disableAction.value) return;

  // Commande normale en attente
  if (
    currentStatus === 1 &&
    !isGroupage.value &&
    canConfirm.value &&
    (!isUKOrder.value || brexitChecked.value)
  ) {
    handleConfirmOrderClick(4, "la confirmation");
    return;
  }

  // Commande groupage en attente (1 ou 9)
  if ((currentStatus === 1 || currentStatus === 9) && isGroupage.value) {
    handleConfirmOrderGroupage();
  }
};

// Gérer le changement du nombre de factures (depuis UploadZone)

// Charger les validations de la commande
const loadOrderValidations = async () => {
  if (!selectedOrderId.value) return;

  try {
    const validations = await getOrderValidations(selectedOrderId.value);

    disableAction.value = validations.disableAction;
    activeExpedi.value = validations.activeExpedi;
    // canConfirmGroupage : toujours true (la facture sera gérée dans la modal)
    canConfirmGroupage.value = true;

    // canReadyForPickup : toujours true (la facture sera gérée dans la modal)
    canReadyForPickup.value = true;
  } catch (error) {
    console.error("Erreur lors du chargement des validations:", error);
    // En cas d'erreur, on garde les valeurs par défaut (true pour permettre les actions)
  }
};

// Initialisation
const handleOrderLabelsChanged = () => {
  refreshLabelsState();
};

onMounted(async () => {
  if (!authStore.isInitialized) {
    await authStore.checkAuth();
  }

  if (!authStore.isAuthenticated) {
    // Vérifier si l'utilisateur est un admin EFP authentifié
    const { useAdminEfpStore } = await import("@/stores/adminEfp");
    const adminEfp = useAdminEfpStore();
    const isAdminEfpAuth =
      adminEfp.isAdminEfpValidated || (await adminEfp.validate());
    if (!isAdminEfpAuth) {
      router.push({ name: "auth" });
      return;
    }
  }
  // Vérifier si un ID est passé en paramètre de route
  if (route.params.id) {
    const id = Array.isArray(route.params.id)
      ? parseInt(route.params.id[0], 10)
      : parseInt(route.params.id as string, 10);

    if (!isNaN(id)) {
      selectedOrderId.value = id;
      await loadOrderData();

      // Scroller vers le statut si demandé (depuis le bouton vert de la liste)
      if (route.query.scrollTo === "statut") {
        await nextTick();
        const el = document.getElementById("statutCommande");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    }
  }

  window.addEventListener("orderLabelsChanged", handleOrderLabelsChanged);
});

onUnmounted(() => {
  window.removeEventListener("orderLabelsChanged", handleOrderLabelsChanged);
});

// Réagir au changement de l'ID de route (navigation SPA entre /orderdetails/:id)
watch(
  () => route.params.id,
  async (newId) => {
    if (!newId) return;
    const id = Array.isArray(newId)
      ? parseInt(newId[0], 10)
      : parseInt(newId as string, 10);
    if (!isNaN(id) && id !== selectedOrderId.value) {
      selectedOrderId.value = id;
      await loadOrderData();
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (selectedOrderId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: handleGoBack,
              class: "flex items-center gap-2 text-black hover:text-black transition-colors self-start"
            }, [
              _cache[20] || (_cache[20] = _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)),
              _createElementVNode("span", _hoisted_4, _toDisplayString(isFromGroupage.value ? "Retour au groupage" : "Retour aux commandes"), 1)
            ])
          ]),
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, [
                  _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-exclamation-circle mr-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[22] || (_cache[22] = [
                _createElementVNode("i", { class: "fas fa-spinner fa-spin text-2xl text-black" }, null, -1),
                _createElementVNode("p", { class: "mt-2 text-black" }, "Chargement des détails de la commande...", -1)
              ])))
            : _createCommentVNode("", true),
          (!isLoading.value && !errorMessage.value && orderData.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(OrderDetailsSection, {
                  orderId: selectedOrderId.value,
                  loading: isLoading.value,
                  collapsible: true,
                  disableAction: disableAction.value,
                  onCollapsed: _cache[0] || (_cache[0] = ($event: any) => (isOrderDetailsCollapsed.value = $event)),
                  onReplacementConfirmation: _cache[1] || (_cache[1] = ($event: any) => (replacementConfirmation.value = $event)),
                  class: "mb-6"
                }, null, 8, ["orderId", "loading", "disableAction"]),
                (isFreeShippingOrder.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[23] || (_cache[23] = [
                      _createElementVNode("p", { class: "font-semibold text-emerald-900" }, [
                        _createElementVNode("i", { class: "fas fa-gift mr-2" }),
                        _createTextVNode("Livraison gratuite ")
                      ], -1),
                      _createElementVNode("p", { class: "mt-1 text-sm text-emerald-800" }, " Cette commande est expédiée gratuitement par votre boutique. Aucun identifiant de livraison eFashion n'est requis. ", -1)
                    ])))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(ClientInfo, {
                    orderId: selectedOrderId.value,
                    collapsible: true,
                    onInvoiceUploaded: handleInvoiceUploaded,
                    onCollapsed: _cache[2] || (_cache[2] = ($event: any) => (isClientInfoCollapsed.value = $event))
                  }, null, 8, ["orderId"]),
                  _createVNode(AddressDetails, {
                    orderId: selectedOrderId.value,
                    collapsible: true,
                    "carrier-message": carrierMessage.value,
                    "has-existing-labels": hasExistingLabels.value,
                    onCollapsed: _cache[3] || (_cache[3] = ($event: any) => (isAddressDetailsCollapsed.value = $event))
                  }, null, 8, ["orderId", "carrier-message", "has-existing-labels"])
                ]),
                (_unref(authStore).isImpersonating)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(OrderAdminZone, {
                        class: "min-w-0",
                        orderId: selectedOrderId.value,
                        orderDetail: orderDetailResponse.value
                      }, null, 8, ["orderId", "orderDetail"]),
                      _createVNode(OrderAdminAddresses, {
                        panel: "livraison",
                        orderDetail: orderDetailResponse.value
                      }, null, 8, ["orderDetail"]),
                      _createVNode(OrderAdminAddresses, {
                        panel: "facturation",
                        orderDetail: orderDetailResponse.value
                      }, null, 8, ["orderDetail"])
                    ]))
                  : _createCommentVNode("", true),
                (orderDetailResponse.value?.commentaires != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "flex-shrink-0 w-24" }, [
                          _createElementVNode("p", { class: "text-sm font-bold text-black" }, "Commentaire :")
                        ], -1)),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("p", _hoisted_15, _toDisplayString(orderDetailResponse.value?.commentaires || ""), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (shouldShowGroupageReadiness.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (shouldShowGroupageReadiness.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _cache[26] || (_cache[26] = _createElementVNode("h4", { class: "text-base font-semibold text-black mb-1" }, " Avancement du groupage ", -1)),
                            _createElementVNode("p", _hoisted_18, _toDisplayString(groupageReadiness.value?.countReady || 0) + " prête(s) sur " + _toDisplayString(groupageReadiness.value?.countTotal || 0) + ". ", 1),
                            (groupageReadiness.value && groupageReadiness.value.countTotal > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _cache[25] || (_cache[25] = [
                                  _createTextVNode(" Vous pourrez télécharger vos étiquettes lorsque toutes les commandes du groupage seront prêtes."),
                                  _createElementVNode("br", null, null, -1),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" Une notification par email vous sera envoyée dès que les étiquettes seront générées."),
                                  _createElementVNode("br", null, null, -1),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" Celles-ci sont produites automatiquement toutes les heures, entre 8h et 14h. ")
                                ])))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (orderDetailResponse.value?.outsideEuShippingZone === true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[27] || (_cache[27] = [
                      _createElementVNode("p", { class: "text-sm font-semibold text-amber-950" }, [
                        _createElementVNode("i", { class: "fas fa-exclamation-triangle mr-2" }),
                        _createTextVNode(" Destination hors Union européenne : pensez à coller la facture commerciale sur le colis avant de le remettre au transporteur. Sans facture visible, la douane peut refuser ou retourner le colis. ")
                      ], -1)
                    ])))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    (canAdminGenerateUsFinalLabels.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _cache[28] || (_cache[28] = _createElementVNode("h4", { class: "mb-2 text-base font-semibold text-black" }, " Étiquette finale USA ", -1)),
                          _cache[29] || (_cache[29] = _createElementVNode("p", { class: "mb-3 text-sm text-indigo-800" }, " Le pickup eFashion est effectué. Cette action génère les étiquettes uniquement pour cette commande. ", -1)),
                          _createElementVNode("button", {
                            type: "button",
                            class: "rounded bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-700 disabled:cursor-wait disabled:bg-gray-400",
                            disabled: isGeneratingAdminUsLabels.value,
                            onClick: generateAdminUsFinalLabels
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass([isGeneratingAdminUsLabels.value ? 'fas fa-spinner fa-spin' : 'fas fa-tag', "mr-2"])
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(isGeneratingAdminUsLabels.value
                    ? "Génération..."
                    : hasExistingLabels.value
                      ? "Régénérer pour cette commande"
                      : "Générer pour cette commande"), 1)
                          ], 8, _hoisted_24)
                        ]))
                      : _createCommentVNode("", true),
                    (shouldShowPackageDetails.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("h4", _hoisted_26, _toDisplayString(isOwnCarrierDirectOrder.value
                  ? "Tickets eFashion et bordereau d’enlèvement"
                  : "Imprimer étiquettes de groupage"), 1),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("button", {
                              onClick: handleGeneratePackageDetails,
                              disabled: 
                    isGeneratingPackageDetails.value || isSavingParcelDimensions.value
                  ,
                              class: "flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
                            }, [
                              (
                      !isGeneratingPackageDetails.value && !isSavingParcelDimensions.value
                    )
                                ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                                : (_openBlock(), _createElementBlock("i", _hoisted_30)),
                              _createElementVNode("span", null, _toDisplayString(isGeneratingPackageDetails.value || isSavingParcelDimensions.value
                      ? "Generation..."
                      : "Telecharger"), 1)
                            ], 8, _hoisted_28)
                          ]),
                          (isOwnCarrierDirectOrder.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_31, " Collez un ticket sur chaque colis. Faites signer le bordereau par le chauffeur et conservez-le. "))
                            : (_openBlock(), _createElementBlock("p", _hoisted_32, _cache[30] || (_cache[30] = [
                                _createElementVNode("strong", null, "Avant téléchargement : facture + dimensions/poids des colis.", -1),
                                _createTextVNode(" Puis imprimez les étiquettes, collez-les sur vos colis et remettez-les à Easy Express. ")
                              ])))
                        ]))
                      : _createCommentVNode("", true),
                    (shouldShowLabelZone.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          (canShowLabelGenerateCta.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createElementVNode("h4", _hoisted_35, " Télécharger vos étiquettes " + _toDisplayString(orderCarrierLibelle.value || ""), 1),
                                _cache[32] || (_cache[32] = _createElementVNode("p", { class: "mb-3 text-sm text-gray-700" }, " Renseignez la facture, les dimensions et le poids des colis pour générer vos étiquettes. ", -1)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors",
                                  disabled: isCheckingLabels.value,
                                  onClick: handleRegenerateLabels
                                }, _cache[31] || (_cache[31] = [
                                  _createElementVNode("i", { class: "fas fa-tags mr-2" }, null, -1),
                                  _createTextVNode(" Générer vos étiquettes ")
                                ]), 8, _hoisted_36)
                              ]))
                            : _createCommentVNode("", true),
                          (canShowAdminRegenerateLabelsCta.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "px-3 py-1.5 bg-amber-600 text-white rounded text-sm hover:bg-amber-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors",
                                  disabled: isCheckingLabels.value || isAdminRegeneratingLabels.value,
                                  onClick: askAdminRegenerateNormalLabels
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass([
                      isAdminRegeneratingLabels.value
                        ? 'fas fa-spinner fa-spin'
                        : 'fas fa-sync-alt'
                    , "mr-2"])
                                  }, null, 2),
                                  _createTextVNode(" " + _toDisplayString(isAdminRegeneratingLabels.value
                      ? "Préparation..."
                      : "Régénérer les étiquettes"), 1)
                                ], 8, _hoisted_38)
                              ]))
                            : _createCommentVNode("", true),
                          (labelModule.value === 'colissimo' && hasExistingLabels.value)
                            ? (_openBlock(), _createBlock(LabelColissimo, {
                                key: `colissimo-${selectedOrderId.value}`,
                                "order-id": selectedOrderId.value,
                                "order-status": Number(orderData.value.statut) || 0,
                                "nb-colis-max": orderData.value.packages || 1,
                                "poids-total": orderData.value.weight || 0
                              }, null, 8, ["order-id", "order-status", "nb-colis-max", "poids-total"]))
                            : (labelModule.value === 'dpd' && hasExistingLabels.value)
                              ? (_openBlock(), _createBlock(LabelDPD, {
                                  key: `dpd-${selectedOrderId.value}`,
                                  "order-id": selectedOrderId.value,
                                  "order-status": Number(orderData.value.statut) || 0,
                                  "carrier-name": orderCarrierLibelle.value || 'DPD',
                                  "nb-colis-max": orderData.value.packages || 1,
                                  "poids-total": orderData.value.weight || 0
                                }, null, 8, ["order-id", "order-status", "carrier-name", "nb-colis-max", "poids-total"]))
                              : (labelModule.value === 'ups' && hasExistingLabels.value)
                                ? (_openBlock(), _createBlock(LabelUPS, {
                                    key: `ups-${selectedOrderId.value}`,
                                    "order-id": selectedOrderId.value,
                                    "order-status": Number(orderData.value.statut) || 0,
                                    "carrier-name": orderCarrierLibelle.value || 'UPS',
                                    "nb-colis-max": orderData.value.packages || 1,
                                    "poids-total": orderData.value.weight || 0
                                  }, null, 8, ["order-id", "order-status", "carrier-name", "nb-colis-max", "poids-total"]))
                                : (labelModule.value === 'easy' && hasExistingLabels.value)
                                  ? (_openBlock(), _createBlock(LabelEasy, {
                                      key: `easy-${selectedOrderId.value}`,
                                      "order-id": selectedOrderId.value,
                                      "order-status": Number(orderData.value.statut) || 0,
                                      "carrier-name": orderCarrierLibelle.value || 'Transporteur',
                                      "id-livraison": 
                  orderData.value.id_livraison ? Number(orderData.value.id_livraison) : null
                ,
                                      "nb-colis-max": orderData.value.packages || 1,
                                      "poids-total": orderData.value.weight || 0
                                    }, null, 8, ["order-id", "order-status", "carrier-name", "id-livraison", "nb-colis-max", "poids-total"]))
                                  : (labelModule.value === 'freeShipping')
                                    ? (_openBlock(), _createBlock(LabelFreeShipping, {
                                        key: `freeshipping-${selectedOrderId.value}`,
                                        "order-id": selectedOrderId.value,
                                        "order-status": Number(orderData.value.statut) || 0
                                      }, null, 8, ["order-id", "order-status"]))
                                    : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    (orderDetailResponse.value?.pickupColisInfo?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _cache[34] || (_cache[34] = _createElementVNode("h4", { class: "text-sm font-semibold text-black mb-2" }, " Information du pickup/dépose ", -1)),
                          _createElementVNode("table", _hoisted_41, [
                            _cache[33] || (_cache[33] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", { class: "border-b" }, [
                                _createElementVNode("th", { class: "text-left py-1" }, "Nb colis"),
                                _createElementVNode("th", { class: "text-left py-1" }, "Réceptionnaire"),
                                _createElementVNode("th", { class: "text-left py-1" }, "Date pickup/déposée")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderDetailResponse.value.pickupColisInfo, (colis) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: colis.id_colis_pickup,
                                  class: "border-b"
                                }, [
                                  _createElementVNode("td", _hoisted_42, _toDisplayString(orderDetailResponse.value?.nb_colis ?? colis.nb_colis), 1),
                                  _createElementVNode("td", _hoisted_43, _toDisplayString(colis.nom_reception), 1),
                                  _createElementVNode("td", _hoisted_44, _toDisplayString(colis.date_creation || "—"), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (shouldShowParcelScanInfo.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("p", _hoisted_46, " Colis scannes : " + _toDisplayString(orderDetailResponse.value?.parcelScanInfo?.scannedCount || 0) + " / " + _toDisplayString(orderDetailResponse.value?.parcelScanInfo?.expectedCount || 0), 1),
                          (
                  (orderDetailResponse.value?.parcelScanInfo?.scannedTrackingNumbers
                    ?.length || 0) > 0
                )
                            ? (_openBlock(), _createElementBlock("p", _hoisted_47, " Numeros scannes : "))
                            : _createCommentVNode("", true),
                          (scannedParcels.value.length)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_48, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scannedParcels.value, (item) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: item.tracking,
                                    class: "flex flex-wrap items-center gap-x-2 gap-y-1"
                                  }, [
                                    _cache[36] || (_cache[36] = _createElementVNode("i", { class: "fas fa-check-circle text-green-600" }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(getScannedParcelLabel(item)), 1),
                                    (item.carrierTrackingNumber)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _cache[35] || (_cache[35] = _createElementVNode("span", null, "— Numéro de suivi :", -1)),
                                          (
                        getScannedTrackingUrl(
                          item.carrierTrackingNumber,
                          item.carrierId,
                        )
                      )
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                href: getScannedTrackingUrl(item.carrierTrackingNumber, item.carrierId)!,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                class: "text-indigo-600 hover:text-indigo-800 underline font-medium"
                                              }, _toDisplayString(formatScannedTracking(
                          item.carrierTrackingNumber,
                          item.carrierId,
                        )), 9, _hoisted_49))
                                            : (_openBlock(), _createElementBlock("strong", _hoisted_50, _toDisplayString(formatScannedTracking(
                          item.carrierTrackingNumber,
                          item.carrierId,
                        )), 1))
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (item.scannedAt)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_51, " (scanné le " + _toDisplayString(item.scannedAt) + ") ", 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(ModalComp, {
                  "is-visible": showConfirmModal.value,
                  title: confirmModalTitle.value,
                  content: confirmModalMessage.value,
                  "cancel-text": "Annuler",
                  "confirm-text": "Confirmer",
                  size: "sm",
                  "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showConfirmModal.value = $event)),
                  onConfirm: executePendingAction
                }, null, 8, ["is-visible", "title", "content"]),
                _createVNode(CancelOrderModal, {
                  "is-visible": showCancelModal.value,
                  "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => ((showCancelModal).value = $event)),
                  loading: isLoading.value,
                  onConfirm: confirmCancelOrder
                }, null, 8, ["is-visible", "loading"]),
                (selectedOrderId.value && orderDetailResponse.value)
                  ? (_openBlock(), _createBlock(FreeShippingConfirmationModal, {
                      key: 5,
                      "is-visible": showFreeShippingConfirmationModal.value,
                      "order-id": selectedOrderId.value,
                      "order-group-id": Number(orderDetailResponse.value.id_commande_groupe || 0),
                      "order-date": orderDetailResponse.value.dateCommande || new Date().toISOString(),
                      "invoice-id": orderDetailResponse.value.id_commande_name,
                      loading: isConfirmingFreeShipping.value,
                      "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => (showFreeShippingConfirmationModal.value = $event)),
                      onConfirm: handleConfirmFreeShipping
                    }, null, 8, ["is-visible", "order-id", "order-group-id", "order-date", "invoice-id", "loading"]))
                  : _createCommentVNode("", true),
                (orderData.value && orderDetailResponse.value && selectedOrderId.value)
                  ? (_openBlock(), _createBlock(LabelGenerationModal, {
                      key: 6,
                      isVisible: showLabelGenerationModal.value,
                      orderId: selectedOrderId.value,
                      orderStatus: orderData.value.statut || 0,
                      idLivraison: 
            orderData.value.id_livraison ? Number(orderData.value.id_livraison) : null
          ,
                      carrierName: orderCarrierLibelle.value || undefined,
                      "country-code": orderDetailResponse.value?.adresseLivraison?.pays?.code,
                      "postal-code": orderDetailResponse.value?.adresseLivraison?.codePostal,
                      "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => (showLabelGenerationModal.value = $event)),
                      onLabelsGenerated: handleLabelsGenerated,
                      onParcelRemoved: _cache[8] || (_cache[8] = ($event: any) => (loadOrderData(false)))
                    }, null, 8, ["isVisible", "orderId", "orderStatus", "idLivraison", "carrierName", "country-code", "postal-code"]))
                  : _createCommentVNode("", true),
                (orderData.value && orderDetailResponse.value && selectedOrderId.value)
                  ? (_openBlock(), _createBlock(LabelGenerationModal, {
                      key: 7,
                      isVisible: showRegenerateLabelModal.value,
                      orderId: selectedOrderId.value,
                      orderStatus: orderData.value.statut || 0,
                      idLivraison: 
            orderData.value.id_livraison ? Number(orderData.value.id_livraison) : null
          ,
                      carrierName: orderCarrierLibelle.value || undefined,
                      "country-code": orderDetailResponse.value?.adresseLivraison?.pays?.code,
                      "postal-code": orderDetailResponse.value?.adresseLivraison?.codePostal,
                      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showRegenerateLabelModal.value = $event)),
                      onLabelsGenerated: handleLabelsRegenerated,
                      onParcelRemoved: _cache[10] || (_cache[10] = ($event: any) => (loadOrderData(false)))
                    }, null, 8, ["isVisible", "orderId", "orderStatus", "idLivraison", "carrierName", "country-code", "postal-code"]))
                  : _createCommentVNode("", true),
                (selectedOrderId.value)
                  ? (_openBlock(), _createBlock(ConfirmParcelDimensionsModal, {
                      key: 8,
                      "is-visible": showConfirmDimensionsModal.value,
                      "order-id": selectedOrderId.value,
                      "initial-dimensions": existingParcelDimensions.value,
                      "calculated-weight": orderDetailResponse.value?.poids,
                      "country-code": orderDetailResponse.value?.adresseLivraison?.pays?.code,
                      "postal-code": orderDetailResponse.value?.adresseLivraison?.codePostal,
                      "id-livraison": 
            orderData.value?.id_livraison ? Number(orderData.value.id_livraison) : null
          ,
                      loading: isSavingParcelDimensions.value || isGeneratingPackageDetails.value,
                      "require-invoice": true,
                      "has-invoice": hasUploadedInvoices.value,
                      "order-group-id": orderDetailResponse.value?.id_commande_groupe || 0,
                      "order-date": 
            orderDetailResponse.value?.commandeGroupe?.date_creation ||
            new Date().toISOString()
          ,
                      "invoice-id": orderDetailResponse.value?.id_commande_name || undefined,
                      "onUpdate:isVisible": _cache[11] || (_cache[11] = ($event: any) => (showConfirmDimensionsModal.value = $event)),
                      onConfirm: handleConfirmDimensionsAndDownload,
                      onRemoved: _cache[12] || (_cache[12] = ($event: any) => (loadOrderData(false))),
                      onRemoveError: _unref(error),
                      onInvoiceUploaded: checkInvoices
                    }, null, 8, ["is-visible", "order-id", "initial-dimensions", "calculated-weight", "country-code", "postal-code", "id-livraison", "loading", "has-invoice", "order-group-id", "order-date", "invoice-id", "onRemoveError"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("h4", _hoisted_53, [
                    _cache[37] || (_cache[37] = _createElementVNode("span", null, "Statut de la commande :", -1)),
                    _createElementVNode("span", _hoisted_54, _toDisplayString(orderDetailResponse.value?.id_commande_groupe_name ||
                (orderDetailResponse.value?.id_commande_groupe
                  ? `#${orderDetailResponse.value.id_commande_groupe}`
                  : orderData.value?.idCommandeName || `#${selectedOrderId.value}`)), 1)
                  ]),
                  (isAdmin.value && orderData.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        (orderData.value.statut !== 1 && orderData.value.statut !== 12)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "px-4 py-2 text-sm rounded-lg text-white bg-amber-600 hover:bg-amber-700 disabled:bg-gray-300 disabled:cursor-not-allowed",
                              disabled: reverting.value,
                              onClick: askRemettreEnAttente
                            }, [
                              (reverting.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_57))
                                : _createCommentVNode("", true),
                              _cache[38] || (_cache[38] = _createTextVNode(" Repasser en attente de confirmation "))
                            ], 8, _hoisted_56))
                          : _createCommentVNode("", true),
                        (orderData.value.statut !== 1 && orderData.value.statut !== 12)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "px-4 py-2 text-sm rounded-lg text-white bg-red-600 hover:bg-red-700 disabled:bg-gray-300 disabled:cursor-not-allowed",
                              disabled: orderData.value.statut === 3 || isLoading.value || !disableAction.value,
                              onClick: handleCancelOrder
                            }, [
                              (isLoading.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_59))
                                : _createCommentVNode("", true),
                              _cache[39] || (_cache[39] = _createTextVNode(" Annuler la commande "))
                            ], 8, _hoisted_58))
                          : _createCommentVNode("", true),
                        (orderData.value.statut !== 12)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              class: "px-4 py-2 text-sm rounded-lg text-white bg-red-700 hover:bg-red-800 disabled:bg-gray-300 disabled:cursor-not-allowed",
                              disabled: updatingBlocking.value,
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (demanderModificationBlocage(true)))
                            }, [
                              (updatingBlocking.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_61))
                                : (_openBlock(), _createElementBlock("i", _hoisted_62)),
                              _cache[40] || (_cache[40] = _createTextVNode(" Bloquer "))
                            ], 8, _hoisted_60))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              type: "button",
                              class: "px-4 py-2 text-sm rounded-lg text-white bg-green-600 hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed",
                              disabled: updatingBlocking.value,
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (demanderModificationBlocage(false)))
                            }, [
                              (updatingBlocking.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_64))
                                : (_openBlock(), _createElementBlock("i", _hoisted_65)),
                              _cache[41] || (_cache[41] = _createTextVNode(" Débloquer "))
                            ], 8, _hoisted_63))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                'text-center p-4 rounded-lg border-2 transition-all',
                getStatusClass('attente', orderData.value?.statut, isGroupage.value),
              ])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                  'w-8 h-8 rounded-full flex items-center justify-center mx-auto mb-2',
                  getStatusIconClass('attente', orderData.value?.statut, isGroupage.value),
                ])
                      }, _cache[42] || (_cache[42] = [
                        _createElementVNode("i", { class: "fas fa-clock text-white text-sm" }, null, -1)
                      ]), 2),
                      _createElementVNode("h5", {
                        class: _normalizeClass([
                  'font-medium text-sm mb-1',
                  getStatusTextClass('attente', orderData.value?.statut, isGroupage.value),
                ])
                      }, " En attente de confirmation ", 2),
                      (orderData.value?.statut === 1 && !isGroupage.value && isUKOrder.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["mt-3 p-2 rounded border text-left", 
                  brexitChecked.value
                    ? 'bg-green-50 border-green-300'
                    : 'bg-red-50 border-red-300'
                ])
                          }, [
                            _createElementVNode("label", _hoisted_67, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((brexitChecked).value = $event)),
                                class: "mt-0.5 flex-shrink-0"
                              }, null, 512), [
                                [_vModelCheckbox, brexitChecked.value]
                              ]),
                              _cache[43] || (_cache[43] = _createElementVNode("span", null, [
                                _createTextVNode(" J'ai pris connaissance et accepte les nouvelles consignes d'envois export Brexit dont la prise en charge des frais de retour en cas de non-respect "),
                                _createElementVNode("a", {
                                  href: "https://drive.google.com/file/d/1tzcOlS2n15NjN-uhVP92PW9wYcUGcoXs/view?usp=sharing",
                                  target: "_blank",
                                  class: "text-blue-600 hover:underline ml-1"
                                }, "Cliquer ici voir document")
                              ], -1))
                            ])
                          ], 2))
                        : _createCommentVNode("", true),
                      (orderData.value?.statut === 1 && !isGroupage.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            (confirmButtonHelpMessage.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_69, [
                                  _cache[44] || (_cache[44] = _createElementVNode("i", { class: "fas fa-info-circle mr-1" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(confirmButtonHelpMessage.value), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (handleConfirmOrderClick(4, 'la confirmation'))),
                              disabled: 
                    !disableAction.value ||
                    !canConfirm.value ||
                    (isUKOrder.value && !brexitChecked.value)
                  ,
                              class: "w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed text-sm"
                            }, _toDisplayString(replacementConfirmation.value ? 'Confirmer les remplacements' : 'Confirmer la commande'), 9, _hoisted_70)
                          ]))
                        : (
                  (orderData.value?.statut === 1 || orderData.value?.statut === 9) &&
                  isGroupage.value &&
                  disableAction.value
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                              _createElementVNode("button", {
                                onClick: handleConfirmOrderGroupage,
                                disabled: !canConfirmGroupage.value,
                                class: "w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed text-sm"
                              }, _toDisplayString(orderData.value?.statut === 1 && replacementConfirmation.value ? 'Confirmer les remplacements' : 'Confirmer'), 9, _hoisted_72),
                              (confirmButtonHelpMessage.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_73, [
                                    _cache[45] || (_cache[45] = _createElementVNode("i", { class: "fas fa-info-circle mr-1" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(confirmButtonHelpMessage.value), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (
                  (orderData.value?.statut === 1 || orderData.value?.statut === 9) &&
                  isGroupage.value &&
                  !disableAction.value
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, _cache[46] || (_cache[46] = [
                                _createElementVNode("p", { class: "text-sm text-amber-600 italic" }, [
                                  _createElementVNode("i", { class: "fas fa-info-circle mr-1" }),
                                  _createTextVNode(" Vous ne pouvez pas confirmer : la facture mensuelle a déjà été générée pour ce mois. ")
                                ], -1)
                              ])))
                            : _createCommentVNode("", true)
                    ], 2),
                    (!isGroupage.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass([
                'text-center p-4 rounded-lg border-2 transition-all',
                getStatusClass('confirm', orderData.value?.statut, isGroupage.value),
              ])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  'w-8 h-8 rounded-full flex items-center justify-center mx-auto mb-2',
                  getStatusIconClass('confirm', orderData.value?.statut, isGroupage.value),
                ])
                          }, _cache[47] || (_cache[47] = [
                            _createElementVNode("i", { class: "fas fa-check text-white text-sm" }, null, -1)
                          ]), 2),
                          _createElementVNode("h5", {
                            class: _normalizeClass([
                  'font-medium text-sm mb-1',
                  getStatusTextClass('confirm', orderData.value?.statut, isGroupage.value),
                ])
                          }, " Commande confirmée ", 2),
                          (
                  orderData.value?.statut !== 1 &&
                  orderData.value?.statut !== 2 &&
                  orderData.value?.statut !== 3 &&
                  activeExpedi.value &&
                  disableAction.value
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_75))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true),
                    (isGroupage.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass([
                'text-center p-4 rounded-lg border-2 transition-all',
                getStatusClass(
                  'attenteEnlevement',
                  orderData.value?.statut,
                  isGroupage.value,
                ),
              ])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  'w-8 h-8 rounded-full flex items-center justify-center mx-auto mb-2',
                  getStatusIconClass(
                    'attenteEnlevement',
                    orderData.value?.statut,
                    isGroupage.value,
                  ),
                ])
                          }, _cache[48] || (_cache[48] = [
                            _createElementVNode("i", { class: "fas fa-boxes text-white text-sm" }, null, -1)
                          ]), 2),
                          _createElementVNode("h5", {
                            class: _normalizeClass([
                  'font-medium text-sm mb-1',
                  getStatusTextClass(
                    'attenteEnlevement',
                    orderData.value?.statut,
                    isGroupage.value,
                  ),
                ])
                          }, _toDisplayString(pickupStepLabel.value), 3)
                        ], 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass([
                'text-center p-4 rounded-lg border-2 transition-all',
                getStatusClass('expediee', orderData.value?.statut, isGroupage.value),
              ])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                  'w-8 h-8 rounded-full flex items-center justify-center mx-auto mb-2',
                  getStatusIconClass('expediee', orderData.value?.statut, isGroupage.value),
                ])
                      }, _cache[49] || (_cache[49] = [
                        _createElementVNode("i", { class: "fas fa-truck text-white text-sm" }, null, -1)
                      ]), 2),
                      _createElementVNode("h5", {
                        class: _normalizeClass([
                  'font-medium text-sm mb-1',
                  getStatusTextClass('expediee', orderData.value?.statut, isGroupage.value),
                ])
                      }, " Commande expédiée ", 2)
                    ], 2),
                    (orderData.value?.statut !== 12)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: _normalizeClass([
                'text-center p-4 rounded-lg border-2 transition-all',
                getStatusClass('annulee', orderData.value?.statut, isGroupage.value),
              ])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  'w-8 h-8 rounded-full flex items-center justify-center mx-auto mb-2',
                  getStatusIconClass('annulee', orderData.value?.statut, isGroupage.value),
                ])
                          }, _cache[50] || (_cache[50] = [
                            _createElementVNode("i", { class: "fas fa-times text-white text-sm" }, null, -1)
                          ]), 2),
                          _createElementVNode("h5", {
                            class: _normalizeClass([
                  'font-medium text-sm mb-1',
                  getStatusTextClass('annulee', orderData.value?.statut, isGroupage.value),
                ])
                          }, " Commande annulée ", 2),
                          (orderData.value?.statut === 1 && disableAction.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                _createElementVNode("button", {
                                  onClick: handleCancelOrder,
                                  class: "w-full px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors text-sm"
                                }, " Annuler ")
                              ]))
                            : _createCommentVNode("", true)
                        ], 2))
                      : (_openBlock(), _createElementBlock("div", _hoisted_77, _cache[51] || (_cache[51] = [
                          _createElementVNode("div", { class: "w-8 h-8 rounded-full flex items-center justify-center mx-auto mb-2 bg-red-600" }, [
                            _createElementVNode("i", { class: "fas fa-ban text-white text-sm" })
                          ], -1),
                          _createElementVNode("h5", { class: "font-bold text-sm mb-1" }, "Commande bloquée", -1),
                          _createElementVNode("p", { class: "text-xs" }, "Cette commande ne peut pas poursuivre son traitement.", -1)
                        ])))
                  ])
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("button", {
                    onClick: handleGoBack,
                    class: "flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
                  }, _cache[52] || (_cache[52] = [
                    _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1),
                    _createElementVNode("span", null, "Retourner sur la liste", -1)
                  ])),
                  _createElementVNode("button", {
                    onClick: handleDownloadPrecommande,
                    disabled: isLoading.value || !orderData.value,
                    class: "flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  }, _cache[53] || (_cache[53] = [
                    _createElementVNode("i", { class: "fas fa-download" }, null, -1),
                    _createElementVNode("span", null, "Télécharger la pré-commande", -1)
                  ]), 8, _hoisted_79),
                  (canPrintJustificatifExpedition.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: handleDownloadJustificatifExpedition,
                        disabled: isLoading.value || !orderData.value,
                        class: "flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
                        title: "Document destiné à l'acheteur"
                      }, _cache[54] || (_cache[54] = [
                        _createElementVNode("i", { class: "fas fa-print" }, null, -1),
                        _createElementVNode("span", null, "Justificatif d'expédition", -1)
                      ]), 8, _hoisted_80))
                    : _createCommentVNode("", true),
                  (isAdmin.value && !isGroupage.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: handleDownloadSupplierInvoice,
                        disabled: isLoading.value || !orderData.value,
                        class: "flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      }, _cache[55] || (_cache[55] = [
                        _createElementVNode("i", { class: "fas fa-file-download" }, null, -1),
                        _createElementVNode("span", null, "Télécharger la facture", -1)
                      ]), 8, _hoisted_81))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_82, [
                (!isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, _cache[56] || (_cache[56] = [
                      _createStaticVNode("<div class=\"text-center py-12\"><div class=\"bg-yellow-50 border border-yellow-200 rounded-lg p-6 inline-block\"><i class=\"fas fa-exclamation-triangle text-yellow-400 text-4xl mb-4\"></i><div class=\"text-yellow-800 font-medium mb-2\"> Aucune commande sélectionnée </div><div class=\"text-yellow-600 text-sm\"> Veuillez sélectionner une commande depuis la liste des commandes. </div></div></div>", 1)
                    ])))
                  : _createCommentVNode("", true)
              ]))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(ConfirmModal), {
      show: showConfirmRemise.value,
      title: "Repasser en attente de confirmation",
      message: "Repasser cette commande en « En attente de confirmation » ?",
      confirmText: "Confirmer",
      showAttentionIcon: true,
      onConfirm: confirmRemettreEnAttente,
      onCancel: cancelRemettreEnAttente
    }, {
      extra: _withCtx(() => [
        (hasExistingLabels.value && !isGroupage.value)
          ? (_openBlock(), _createElementBlock("label", _hoisted_84, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((deleteLabelsOnRemise).value = $event)),
                type: "checkbox",
                class: "mt-1 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
              }, null, 512), [
                [_vModelCheckbox, deleteLabelsOnRemise.value]
              ]),
              _cache[57] || (_cache[57] = _createElementVNode("span", null, [
                _createElementVNode("strong", null, "Supprimer aussi les étiquettes existantes"),
                _createElementVNode("span", { class: "block mt-1 text-amber-900/80" }, " Si coché, le vendeur devra les régénérer après reconfirmation. Sinon, les étiquettes actuelles restent disponibles. ")
              ], -1))
            ]))
          : (hasExistingLabels.value && isGroupage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_85, " Les étiquettes de groupage (gérées à l’entrepôt eFashion) sont conservées. "))
            : (_openBlock(), _createElementBlock("p", _hoisted_86, " Aucune étiquette active sur cette commande. "))
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(ConfirmModal), {
      show: showConfirmAdminRegenerateLabels.value,
      title: "Régénérer les étiquettes",
      message: "Les étiquettes actuelles seront supprimées, puis vous pourrez en générer de nouvelles. Continuer ?",
      confirmText: "Continuer",
      showAttentionIcon: true,
      onConfirm: confirmAdminRegenerateNormalLabels,
      onCancel: _cache[18] || (_cache[18] = ($event: any) => (showConfirmAdminRegenerateLabels.value = false))
    }, null, 8, ["show"]),
    (selectedOrderId.value)
      ? (_openBlock(), _createBlock(OrderBlockingScopeModal, {
          key: 1,
          "is-visible": blocageModalVisible.value,
          bloque: blocageDemande.value,
          "id-commande": selectedOrderId.value,
          loading: updatingBlocking.value,
          "onUpdate:isVisible": _cache[19] || (_cache[19] = ($event: any) => (blocageModalVisible.value = $event)),
          onSelect: modifierBlocage
        }, null, 8, ["is-visible", "bloque", "id-commande", "loading"]))
      : _createCommentVNode("", true)
  ]))
}
}

})